import React, { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import Template from "../../Template";
import PropTypes from "prop-types";
import WhatsAppControl from "./WhatsappControl";
import { useReplaceMessage } from "../../../../hooks/useReplaceMessage";
import Icon from "../../../Icon";
import _Button from "../../../generic/_Button";
const WhatsappForm = ({ step }) => {
  const { values, setFieldValue } = useFormikContext();
  const replaceMessage = useReplaceMessage(values.fieldsInfo);
  const [params, setParams] = useState([]);
  const [countParamsMessage, setCountParamsMessage] = useState(0);

  const cleanParams = (data = []) => {
    return data.map((item) => {
      return item.replace("{", "").replace("}", "");
    });
  };

  const countParamsMessageWhatsApp = (message) => {
    if (!message) return;
    const matcches = message.match(/{{\d+}}/g);

    const count = new Set(matcches).size;
    setCountParamsMessage(count);
  };

  useEffect(() => {
    let messageWithTemplate = values.whmessage;

    try {
      const matches = messageWithTemplate.match(/{{\d+}}/g);

      if (matches) {
        const allParams = cleanParams(
          values.whparameters.match(/{[^}]+}/g) || []
        );

        const uniqueParamNumbers = [
          ...new Set(
            matches.map((match) => parseInt(match.replace(/[{}]/g, ""), 10))
          ),
        ];

        const paramArray =
          uniqueParamNumbers.length === 1 && allParams.length > 0
            ? [allParams[allParams.length - 1]]
            : allParams;

        setParams(paramArray);

        matches.forEach((match) => {
          const matchNumber = parseInt(match.replace(/[{}]/g, ""), 10);

          if (matchNumber > 0 && paramArray.length >= matchNumber) {
            const paramIndex =
              uniqueParamNumbers.length === 1 ? 0 : matchNumber - 1;

            const field = paramArray[paramIndex]?.trim();

            if (!field) return;

            const currentK = values.fieldsInfo.find(
              (item) => item.vc_keycolumn === field
            );

            if (currentK?.vc_keycolumn) {
              messageWithTemplate = messageWithTemplate.replace(
                match,
                currentK.vc_value
              );
            }
          }
        });
      }
    } catch (e) {
      console.error(e);
    }

    countParamsMessageWhatsApp(values.whmessage);
    setFieldValue("whtemplate", messageWithTemplate);
  }, [values.whparameters, values.whmessage, values.fieldsInfo]);

  return (
    <div className="bg-white rounded-lg px-3 py-1.5">
      <div className="px-4">
        <div className="flex items-end gap-2 my-2">
          <div className="flex items-center justify-center size-8 rounded-full bg-[#009CFF] text-white">
            <span className="font-bold">{step}</span>
          </div>
          <div className="text-xl font-bold text-gray-600">
            Mensaje WhatsApp
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        {/* Control*/}
        <div className="border rounded-lg my-2 flex flex-col justify-between">
          <div>
            <WhatsAppControl />

            {/* Parametros}*/}

            <div className="px-4">
              <div className="text-sm font-semibold">Parámetros</div>
              <div className="border rounded-lg h-[300px]">
                <div className="grid grid-cols-4 gap-1 px-1 py-1">
                  {params.map((item, index) => (
                    <span
                      key={index}
                      className="text-[14px] px-2 py-1 bg-gray-100 rounded-lg flex items-center justify-center"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-1 my-2 px-4">
            <div>
              <div className="text-md text-gray-800">
                Total de parámetros:
                {countParamsMessage > 0 && (
                  <span className="text-red-600"> ({countParamsMessage})</span>
                )}
              </div>
              <_Button
                title="Limpiar parametro"
                style="none"
                className="w-full mt-2"
                icon="delete"
                onClick={() => {
                  setFieldValue("whparameters", "");
                  setParams([]);
                  setFieldValue("whtemplate", "");
                  setFieldValue("whmessage", "");
                  setFieldValue("selectedTemplate", "");
                }}
              />
            </div>
          </div>
        </div>

        {/* Preview*/}
        <div className="border rounded-lg my-2 px-4 py-2">
          <div className="text-md font-semibold text-gray-600">Preview</div>
          <div className="bg-[#E5DDD5] rounded-lg p-4 min-h-[400px]">
            <div className="flex justify-start">
              <div className="max-w-[85%]">
                <div className="bg-white rounded-lg rounded-tl-none shadow-md p-4 relative">
                  <div className="text-[12px] text-foreground leading-relaxed whitespace-pre-wrap break-words">
                    {replaceMessage(values.whtemplate) ||
                      "[En este espacio puedes previsualizar el mensaje de WhatsApp a enviar]"}
                  </div>
                  <div className="flex items-center justify-end gap-1 mt-2">
                    <span className="text-[10px] text-muted-foreground">
                      {new Date().toLocaleTimeString("es", {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </span>
                    <Icon icon="done_all" className={"text-[#53BDEB]"} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-2 border rounded-lg">
        {/* Tabs */}
        <Template
          onChange={(e) => {
            setFieldValue("whparameters", e);
          }}
          value={values.whparameters}
        />
      </div>
    </div>
  );
};

WhatsappForm.propTypes = {
  step: PropTypes.number,
};

export default WhatsappForm;
